module.exports = __webpack_public_path__ + "img/2024big3.5b064d7e.png";